// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8f6189e5","239":"6ef861b7","455":"c59eeb4a"}[chunkId] + ".chunk.js";
};